/* GoalKit — Protection Flocage dans le panier (tiroir + page panier).
   Cocher = ajoute 1 protection ; décocher = la retire.
   Garde-fous : jamais plus d'une protection, et retirée si elle reste seule dans le panier. */
(function () {
  if (window.__gkProtBound) return;
  window.__gkProtBound = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  function drawer() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.getSectionsToRender === 'function' && typeof d.renderContents === 'function' && document.getElementById('CartDrawer') ? d : null;
  }

  function post(url, payload) {
    var d = drawer();
    if (d) {
      payload.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function refresh(state, variantId) {
    var onCartPage = !!document.getElementById('main-cart-items');
    var d = drawer();
    if (onCartPage || !d || !state || !state.sections) { window.location.reload(); return; }
    d.renderContents({ id: Number(variantId) || 0, sections: state.sections });
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'goalkit-protection', cartData: state });
    }
    setTimeout(check, 50);
  }

  function setQty(key, qty) {
    busy = true;
    return Promise.resolve()
      .then(function () { return post('cart/change.js', { id: key, quantity: qty }); })
      .then(function (state) { busy = false; refresh(state); })
      .catch(function () { busy = false; });
  }

  /* Garde-fous après chaque rendu */
  function check() {
    if (busy) return;
    var orphan = document.querySelector('[data-gk-prot][data-orphan]');
    if (orphan && orphan.dataset.key) { setQty(orphan.dataset.key, 0); return; }
    var box = document.querySelector('[data-gk-prot]:not([data-orphan])');
    if (box && box.dataset.key && Number(box.dataset.qty) > 1) setQty(box.dataset.key, 1);
  }

  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-gk-prot-check]');
    if (!cb || busy) return;
    var box = cb.closest('[data-gk-prot]');
    box.classList.add('is-loading');
    busy = true;
    Promise.resolve()
      .then(function () {
        return cb.checked
          ? post('cart/add.js', { items: [{ id: Number(box.dataset.variant), quantity: 1 }] })
          : post('cart/change.js', { id: box.dataset.key, quantity: 0 });
      })
      .then(function (state) {
        busy = false;
        if (state.status) { cb.checked = !cb.checked; box.classList.remove('is-loading'); return; }
        refresh(state, box.dataset.variant);
      })
      .catch(function () { busy = false; cb.checked = !cb.checked; box.classList.remove('is-loading'); });
  });

  /* Après le chargement complet : les composants du panier (Dawn) sont alors prêts */
  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'goalkit-protection') return;
        setTimeout(check, 300);
      });
    }
    check();
  }
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();
